import * as AuthApiClient from '../openapi-clients-generated/auth';
import { configureApiClient } from './helpers';

export const apiAuthClient = new AuthApiClient.ApiClient({
    BASE: import.meta.env.VITE_APP_AUTH_API_URL
});
configureApiClient(apiAuthClient, AuthApiClient.CancelablePromise);
